import { ReactNode } from "react";
import PlanDropDownView from "./PlanDropDownView";

export type PlanViews = "recommended" | "custom";

export class PlanDropDownPresenter {
    plan: BuildingModelCarbonReductionPlan;

    view: "recommended" | "custom";

    recommended: boolean;

    constructor(plan: BuildingModelCarbonReductionPlan, view: PlanViews, recommended: boolean) {
        this.plan = plan;
        this.view = view;
        this.recommended = recommended;
    }

    getElement(): ReactNode {
        if (this.plan.planType === "recommended" && !this.plan.isReported) {
            return null;
        }
        return (
            <PlanDropDownView
                displayName={this.getDisplayValue()}
                isOutdated={this.plan.buildingStateIsOutdated}
                isPublished={this.plan.isPublished}
            />
        );
    }

    getID(): string {
        // we are giving the recommended plan its own special not-really-an-id because otherwise, when the reported plan has been overridden by a custom plan, then we end up failing to show
        // both the recommended plan and also the custom plan in its own right, which then makes it impossible to un-override the overridden plan.
        if (this.recommended) return "recommended";
        return this.plan.id;
    }

    getDisplayValue(maxLength: number = 25): string {
        const name = this.recommended ? "Audette plan" : this.plan?.name;
        if (name.length <= maxLength) return name;
        return `${name.slice(0, maxLength - 3)}...`;
    }

    getURL(tab: string): string {
        return `/buildings/${this.plan.buildingModelUid}/plans/${this.plan.id}/${this.getView()}/${tab}`;
    }

    getView(): string {
        if (this.recommended) return "recommended";
        return "custom";
    }

    match(view: string | undefined, bmcrpID: string): boolean {
        return this.plan.id === bmcrpID && this.getView() === view;
    }
}
